import { createAction } from '@reduxjs/toolkit';
export const FETCH_FEEDBACK = 'FETCH_FEEDBACK';
export const fetchFeedbackAction = createAction(FETCH_FEEDBACK);